import { gql } from "@apollo/client";

export default gql`
  mutation resendVerificationEmail($email: String!){
    resendVerificationEmail(email: $email){
        success
        data
        code
        message
    }
}
`
